<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M288 288h191.1a32 32 0 1 0 0-64H32.9a32 32 0 1 0 0 64z"/></svg>